<template>
  <v-tabs hide-slider class="navbar">
    <v-tab><a href="#experience" v-smooth-scroll>Experiences</a></v-tab>
    <v-tab><a href="#project" v-smooth-scroll>Projects</a></v-tab>
    <v-tab><a href="#mycontact" v-smooth-scroll>Contact</a></v-tab>
  </v-tabs>
</template>

<script>
  export default {
    name: 'NavBar',

    data: () => ({
      
    }),
  }
</script>

<style scoped>
  .navbar {
    padding-left: 10px;
    padding-top: 10px;
  }

  a:link {
    text-decoration: none;
  }

  a:visited {
    text-decoration: none;
  }

  a:hover {
    text-decoration: none;
  }

  a:active {
    text-decoration: none;
  }
</style>